import api from '../api';

import { ParamsBodyEffectSchedule } from 'utils/typeServices';

export const PostEffectSchedule = async ({ token, body }: { token: string, body: ParamsBodyEffectSchedule }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const data = await api.post('v1/Agendamento/EffectSchedule', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    
        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
